import { plainToInstance } from 'class-transformer';
import { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { BiExport } from 'react-icons/bi';
import { useSearchParams } from 'react-router-dom';
import { ReportTicketDto } from '../../commons/dtos/report-ticket.dto';
import { IChatbotAPIPagination } from '../../commons/interfaces/chatbotAPI.interface';
import { IReportFilters } from '../../commons/interfaces/report.interface';
import CustomTable from '../../components/CustomTable';
import Paper from '../../components/Paper';
import ChatbotAPI from '../../services/chatbot.service';
import ReportService from '../../services/report.service';
import FilterSection from '../Report/FilterSection';
import './style.scss';
import tableColumnMetadata from './table.metadata';

const reportService = new ReportService();
const chatbotApi = new ChatbotAPI();

const ReportTicket = () => {
  const initialPagination = { page: 1, pageSize: 10, pageCount: 1, totalCount: 1 };
  const [searchParams] = useSearchParams();

  const [reportTickets, setReportTickets] = useState<ReportTicketDto[]>([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState<IChatbotAPIPagination>(initialPagination);

  const [filtersLoading, setFiltersLoading] = useState(false);
  const [filters, setFilters] = useState<IReportFilters>();

  // Fetch filters
  useEffect(() => {
    const fetchFilters = async () => {
      setFiltersLoading(true);

      const fields = 'units,ticketStatuses';
      const response = await reportService.listReportFilters(fields);

      setFilters(response.data);
      setFiltersLoading(false);
    };

    fetchFilters();
  }, []);

  useEffect(() => {
    const fetchReportTickets = async () => {
      setLoading(true);

      const unitId = searchParams.get('unitId') || '';
      const status = searchParams.get('status') || '';
      const startDate = searchParams.get('startDate') || '';
      const endDate = searchParams.get('endDate') || '';

      const response = await chatbotApi.listTickets(unitId, page, status, startDate, endDate);
      const tickets = plainToInstance(ReportTicketDto, response.data.data);

      setReportTickets(tickets);
      setPagination(response.data.pagination);
      setLoading(false);
    };

    fetchReportTickets();
  }, [page, searchParams]);

  const handleExportClick = async () => {
    const unitId = searchParams.get('unitId') || '';
    const status = searchParams.get('status') || '';
    const startDate = searchParams.get('startDate') || '';
    const endDate = searchParams.get('endDate') || '';
    await chatbotApi.exportTickets(unitId, status, startDate, endDate);
  };

  const handleFooterClick = (value: number) => {
    setPage(page + value);
  };

  const footerProps = {
    onClick: handleFooterClick,
    pagination,
    loading
  };

  return (
    <Paper>
      <Row className="mb-2">
        <Col className="d-flex m-auto">
          <span>Reporte de tickets</span>
        </Col>
        <Col xs={5} className="d-flex justify-content-end">
          <Button variant="outline-primary" onClick={handleExportClick}>
            <BiExport className="button-icon" />
            Exportar
          </Button>
        </Col>
      </Row>
      <FilterSection loading={filtersLoading} filters={filters} />
      <Row className="mt-1">
        <Col>
          <CustomTable<ReportTicketDto>
            data={reportTickets}
            columnsMetadata={tableColumnMetadata}
            footerProps={footerProps}
            loading={loading}
          />
        </Col>
      </Row>
    </Paper>
  );
};

export default ReportTicket;
